
<script setup>

  import { ref, watch, onMounted } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { seenPlayerDialog } from '../stores/activity-2.js';

  import backgroundPath from '../images/map-background.jpg';

  const ready = ref( false );

  onMounted( () => {

    watch( seenPlayerDialog, () => {

      if ( seenPlayerDialog.value ) setTimeout( () => ready.value = true, 100 );

    }, { immediate: true } );

  } );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 2</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Jim Crow Era Traveling</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            It's 1941. You are from Baltimore, Maryland, and planning a trip to visit family in Richmond, Virginia.

            You decide to make a vacation out of it and drive out to the new Lewis Mountain cabins in Shenandoah National Park before continuing on to Richmond.

          </p>

          <h3 class="mt-8 text-2xl md:text-3xl font-medium font-serif italic">About This Activity</h3>

          <p class="mt-4 leading-7 text-neutral-700">

            Put yourself in the driver's seat and navigate through some potential hazards African Americans may have encountered while taking a road trip during the Jim Crow Era.

          </p>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-12 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/2/part/1">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
